import React, { Component } from 'react';
import * as d3 from 'd3';
import numeral from 'numeral';
import * as annotation from 'd3-svg-annotation';
import { Button, TextField } from 'react-md';

class ParticipatingPreferredDataViz extends Component {

  componentDidMount() {
    var dealData = {
      premoneyValuation: 7000000,
      salePrice: 20000000,
      initialInvestment: 3000000,
      liquidationPreference: 1
    }
    //set initial values
    document.getElementById('pre-money-valuation-input').value = dealData.premoneyValuation;
    document.getElementById('initial-investment-input').value = dealData.initialInvestment;
    document.getElementById('liquidation-preference-input').value = dealData.liquidationPreference;
    document.getElementById('sale-price-input').value = dealData.salePrice;

    // structure for chart data is: [ {series A}, {company sale with participating}, {company sale with non-participating} ]
    var chartData;

    function generateChartData(dealData){
      var investorOwnership = calculateInvestorOwnership(dealData);
      var founderOwnership = 1 - investorOwnership;
      var seriesAValuation = parseInt(dealData.initialInvestment, 10) + parseInt(dealData.premoneyValuation, 10);
      var proceedsFromLiquidationPreference = dealData.initialInvestment * dealData.liquidationPreference;
      var salePriceAfterLiquidationPreferenceCashOut = dealData.salePrice - proceedsFromLiquidationPreference;
      var proceedsFromParticipatingInvestorCommonStock = investorOwnership * salePriceAfterLiquidationPreferenceCashOut;
      var proceedsFromInvestorCommonStock = investorOwnership * dealData.salePrice;
      var participatingPreferredProceeds = proceedsFromParticipatingInvestorCommonStock + proceedsFromLiquidationPreference;

      if(doInvestorsConvert(dealData) === true){
        chartData = [
          {
            founders: founderOwnership * seriesAValuation,
            investors: investorOwnership * seriesAValuation
          },
          {
            founders: dealData.salePrice - participatingPreferredProceeds,
            investors: participatingPreferredProceeds
          },
          {
            founders: dealData.salePrice - proceedsFromInvestorCommonStock,
            investors: proceedsFromInvestorCommonStock
          }
        ]
        chartData.forEach(function(bar){
          if(bar.founders < 0){
            bar.founders = 0;
          } else if (bar.investors > dealData.salePrice){
            bar.investors = dealData.salePrice;
          }
        })
      } else {
        chartData = [
          {
            founders: founderOwnership * seriesAValuation,
            investors: investorOwnership * seriesAValuation
          },
          {
            founders: dealData.salePrice - participatingPreferredProceeds,
            investors: participatingPreferredProceeds
          },
          {
            founders: dealData.salePrice - proceedsFromLiquidationPreference,
            investors: proceedsFromLiquidationPreference
          }
        ]
        chartData.forEach(function(bar){
          if(bar.founders < 0){
            bar.founders = 0;
          } else if (bar.investors > dealData.salePrice){
            bar.investors = dealData.salePrice;
          }
        })
      }
    }

    generateChartData(dealData);

    function doInvestorsConvert(dealData){
      if(calculateInvestorOwnership(dealData) * dealData.salePrice > calculateLiquidationPreferenceAmount(dealData)){
        return true;
      } else {
        return false;
      }
    }

    function calculateInvestorOwnership(dealData){
      return dealData.initialInvestment / (parseInt(dealData.premoneyValuation, 10) + parseInt(dealData.initialInvestment, 10));
    }

    function calculateLiquidationPreferenceAmount(dealData){
      return dealData.initialInvestment * dealData.liquidationPreference;
    }

    var margin = {top: 30, right: 120, bottom: 25, left: 120},
        width = 700 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom,
        animationDuration = 1000,
        layers,
        stack = d3.stack()
          .keys(['founders', 'investors'])

    var series = stack(chartData);

    var color = d3.scaleOrdinal(d3.schemeCategory10);

    var xDomain = ["Series A", "Company Sold (Participating)", "Company Sold (Non-Participating)"];
    var keys = ["Founders", "Investors"];

    var x = d3.scaleBand()
      .domain(xDomain)
      .rangeRound([0, width]);

    var y = d3.scaleLinear()
      .range([height, 0]);

    var svg = d3.select('#participating-chart').append('svg')
      .attr('class', 'participating-preferred-svg')
      .attr('viewBox', '0 0 700 300')
      .attr("preserveAspectRatio", "xMidYMid meet")
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    var xAxis = d3.axisBottom(x)

    var yAxis = d3.axisLeft(y)
      .tickFormat(function(d) { return "$" + d3.format(".3s")(d); });

    function animateBars(selection) {
      selection.transition()
        .duration(animationDuration)
        .attr("y", function(d) {
          return y(d[1]);
        })
        .attr("height", function(d){
          return y(d[0]) - y(d[1]);
        });
    };

    y.domain([0, dealData.salePrice]);

    layers = svg.selectAll('.layer')
      .data(series)
      .enter().append('g')
      .attr("class", function(d){
      return d.key;
    })
      .style('fill', function(d,i){ return color(i); })

    layers.selectAll("rect")
      .data(function(d) {
        return d;
      })
    .enter().append("rect")
      .attr("x", function(d, i) {
        return x(xDomain[i]) + 10;
      })
      .attr("width", x.bandwidth() - 20)
      .attr("y", function(d) {
        return y(d[1]);
      })
      .attr("height", function(d){
        return y(d[0]) - y(d[1]);
      })
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseout", mouseout)

    svg.append('g')
      .attr("class", "y axis-participating")
      .call(yAxis)

    svg.append('g')
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)

    svg.append('text')
      .attr("x", (width / 2))
      .attr("y", 0 - (margin.top / 2))
      .attr("text-anchor", "middle")
      .style("font-size", "14px")
      .text("Distribution of Proceeds from Sale of Company")

    var legend = svg.append('g')
      .attr("class", "legend")
      .selectAll('g')
    .data(keys)
      .enter().append('g')
      .attr("transform", function(d,i){
        return "translate(0," + i * 20 + ")"
      });

    legend.append('rect')
      .attr("x", width)
      .attr("width", 19)
      .attr("height", 19)
      .attr("fill", function(d,i){ return color(i) });

    legend.append('text')
      .attr("x", width + 24)
      .attr("y", 9.5)
      .attr("dy", "0.35em")
      .style("font-size", "10px")
      .text(function(d){
        return d;
      });

    var div = d3.select("#participating-chart").append("div")
      .attr("class", "tooltip")
      .style("display", "none");

    function updateDealData(){
      dealData.premoneyValuation = document.querySelector('#pre-money-valuation-input').value;
      dealData.initialInvestment = document.querySelector('#initial-investment-input').value;
      dealData.liquidationPreference = document.querySelector('#liquidation-preference-input').value;
      dealData.salePrice = document.querySelector('#sale-price-input').value;
    }

    function redraw(){
      updateDealData();
      // console.log(dealData);
      y.domain([0, dealData.salePrice]);
      generateChartData(dealData);
      var newSeries = stack(chartData);
      layers = layers.data(newSeries);
      layers.selectAll('rect')
        .data(function(d){
          return d;
        })
        .call(animateBars);

      d3.transition(svg).selectAll('.y.axis-participating')
        .call(yAxis)
        .on('end', function() {
          d3.select(".annotation-group-participating").transition().style("opacity", 0)
            .on("end", function() {
              updateAnnotationsData();
              makeAnnotations.update();
              d3.select(".annotation-group-participating").transition().style("opacity", 1);
            });
        })
    }

    // d3-annotations
    const type = annotation.annotationCalloutRect
    
    var annotations = [{
      note: {
        label: "$" + numeral(chartData[2].founders - chartData[1].founders).format(0,0),
        title: "Additional $$$ to Founders",
        wrap: 80
      },
      x: x("Company Sold (Non-Participating)") + margin.left + margin.right + 23,
      y: y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) + margin.top,
      dy: 50,
      dx: 15,
      subject: {
        width: -(x.bandwidth() - 20),
        height: -(y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) - y(chartData[xDomain.indexOf("Company Sold (Participating)")].founders))
      }
    }]

    const updateAnnotationsData = () => {
      annotations[0].y = y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) + margin.top;
      if (y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) + margin.top > 200) {
        annotations[0].dy = -50;
      } else if (y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) + margin.top < 60) {
        annotations[0].dy = 50;
      }

      if (y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) + margin.top >= 275) {
        annotations[0].subject.height = 1;
      } else {
        annotations[0].subject.height = -(y(chartData[xDomain.indexOf("Company Sold (Non-Participating)")].founders) - y(chartData[xDomain.indexOf("Company Sold (Participating)")].founders));
      }
      annotations[0].note.label = "$" + numeral(chartData[2].founders - chartData[1].founders).format(0,0);

      makeAnnotations.annotations(annotations);
    }

    const makeAnnotations = annotation.annotation()
      .type(type)
      // .editMode(true)
      .annotations(annotations)

    d3.select(".participating-preferred-svg")
      .append("g")
      .attr("class", "annotation-group-participating")
      .call(makeAnnotations)
      
    var updateButton = document.querySelector('#update-participating');
    updateButton.addEventListener('click', redraw);

    function upperCaseFirst(string){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function mouseover() {
      div.style("display", "inline");
      d3.select(this)
        .style("opacity", 0.7);
    }

    function mousemove(d) {
      var key = d3.select(this.parentNode).attr("class");
      var proceeds = d[1] - d[0];
      div
        .html(upperCaseFirst(key) + ':<br><br>$' + numeral(proceeds).format(0,0))
        .style("left", (d3.event.pageX) + "px")
        .style("top", (d3.event.pageY - 400) + "px");
    }

    function mouseout() {
      div.style("display", "none");
      d3.select(this)
        .style("opacity", 1);
    }
  }

  shouldComponentUpdate() {
    return false;
  }
  
  render() {

    return (
      <div style={{marginBottom: '2rem'}}>
        <div id="participating-chart"></div>
        <div className="md-grid">
          <TextField 
            label="Pre-Money Valuation" 
            defaultValue={7000000} 
            className="data-viz-input"
            id="pre-money-valuation-input"></TextField>

          <TextField 
            label="Initial Investment" 
            defaultValue={ 3000000} 
            className="data-viz-input"
            id="initial-investment-input"></TextField>

          <TextField 
            label="Liquidation Preference" 
            defaultValue={ 1 } 
            className="data-viz-input"
            id="liquidation-preference-input"></TextField>

          <TextField 
            label="Sale Price" 
            defaultValue={ 20000000 } 
            className="data-viz-input"
            id="sale-price-input"></TextField>
        </div>
        <div>
          <Button id="update-participating" raised>UPDATE</Button>
        </div>
      </div>
    )
  }
}

export default ParticipatingPreferredDataViz;


// WEBPACK FOOTER //
// ./src/components/ParticipatingPreferredDataViz.js